export const handleKeyPress = (event: React.KeyboardEvent, callback: () => void) => {
    if (event.key === "Enter") {
      callback(); // Call the provided callback function
    }
  };
  